import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { SfLabelText } from './Filter.style';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { useState, useEffect, useMemo } from 'react';
import { getSortController, getSortCriteria } from 'lib/utils/coveo/headlessSort';
import { buildCriterionExpression } from '@coveo/headless';

const SortByRelevanceFilter = (props: any): JSX.Element => {
  const dropDownValues = props?.fields?.data[0]?.fields?.dropdownValue;
  const sortController = useMemo(() => {
    return getSortController(dropDownValues);
  }, []);
  const sortCriteria = useMemo(() => {
    return getSortCriteria(dropDownValues);
  }, []);
  const [state, setState] = useState(sortController.state);

  useEffect(() => sortController.subscribe(() => setState(sortController.state)), []);

  const getCriterionFromName = (name: string) =>
    sortCriteria.find(([criterionName]) => criterionName === name)!;

  const getCurrentCriterion = () => {
    return sortCriteria.find(
      ([, criterion]) => state.sortCriteria === buildCriterionExpression(criterion as any)
    )!;
  };

  const { fields } = props?.fields?.data[0];

  return (
    <Grid item>
      <FormControl fullWidth>
        <SfLabelText id={props.key}>
          <Text field={fields.label}></Text>
        </SfLabelText>
        <Select
          labelId={props.key}
          id="sort-by-select"
          size="small"
          value={getCurrentCriterion()[0]}
          label={props.key}
          type="contained"
          onChange={(e: any) => {
            sortController.sortBy(getCriterionFromName(e.target.value)[1]);
          }}
          sx={{
            color: (theme) => `${theme.palette.neutral7.main} !important`,
          }}
        >
          {sortCriteria.map(([criterionName]) => (
            <MenuItem key={criterionName} value={criterionName}>
              {criterionName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

export default SortByRelevanceFilter;
